import { Fragment, useContext, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { EntityContext } from '../../context/EntityContext';
import { ListContext } from '../../context/ListContext';
import {TfiClose} from "react-icons/tfi";


export default function GridTagFilter() {

  const cancelButtonRef = useRef(null);

  const { openTagSearchModal, setOpenTagSearchModal, tags, list, setList } = useContext(ListContext);
  const {currentTag,  setCurrentTag } = useContext(EntityContext);

  const filterListByTag = (resetSearch) => {
    const newResultList = [];


    for (let a of  list) {
      if (resetSearch === true ) {
          a.hidden = false;
          newResultList?.push(a);
      } else {
        if (a?.tags?.includes(currentTag) === true ) {
          a.hidden = false;
          newResultList?.push(a);
        } else {
          a.hidden = true;
          newResultList?.push(a);
        }
      }
    }
    setList(newResultList);
    setOpenTagSearchModal(false);
  };

  return (
    <Transition.Root show={openTagSearchModal} as={Fragment}>
      <Dialog
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpenTagSearchModal}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >

              <Dialog.Panel className='flex max-w-2xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                <button
                    type='button'
                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                    onClick={() => setOpenTagSearchModal(false)}
                    ref={cancelButtonRef}
                >
                  <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                </button>


                <div className='flex w-full h-full'>
                  <div className={' flex flex-col w-full'}>
                    <Dialog.Title
                        as='h3'
                        className='pt-8 px-8  font-bold text-2xl leading-6 text-gray-900-'>
                      Filter
                    </Dialog.Title>
                    <div className='p-8 pb-0 flex flex-col flex-1  overflow-y-auto'>
                      <p className="text-sm my-2 mb-4 w-full block text-gray-600">
                        {Object.keys(tags)?.map((tag, key) => {
                          return (
                              <div className={"mb-4"} key={key}>
                                <b className="text-gray-900 mb-2 block w-full pb-1">{tags?.[tag]?.name}</b>
                                <div className={"flex flex-wrap gap-2"}>
                                  {Object.keys(tags?.[tag]?.["options"]).map((side, key) => (
                                      <div key={key} onClick={() => setCurrentTag(side)} className={(currentTag === side) ? "px-2 cursor-pointer py-1 bg-gray-900 text-white rounded text-xs border border-gray-900" : "px-2 cursor-pointer py-1 rounded text-xs border border-gray-500"}>{tags?.[tag]?.["options"]?.[side]?.name} ({tags?.[tag]?.["options"]?.[side]?.count})</div>
                                  ))}
                                </div>
                              </div>
                          );

                        })}

                      </p>
                    </div>
                    <div className="p-8 pt-0 sm:flex-row-reverse justify-between flex w-full flex-col-reverse gap-4">
                      <button
                          type="button"
                          className="text-center truncate items-center rounded-md bg-white text-gray-900  border-gray-900 border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"
                          onClick={() => {
                            filterListByTag();
                          }}
                      >
                        Filtern
                      </button>

                      {(currentTag !== null ) && (
                          <button
                              type="button"
                              className="text-center truncate items-center rounded-md bg-white text-red border-red border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"
                              onClick={() => {setOpenTagSearchModal(false); setCurrentTag(null); filterListByTag(true); }}
                              ref={cancelButtonRef}
                          >
                            Zurücksetzen
                          </button>
                      )}

                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
